import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";

export const requestGetMainCategories = async (): Promise<Category[]> => {
  return await instance.get(ApiRoutesCategories.MainCategory);
};
